import { Link } from "gatsby";
import React from "react";
import QuestionIcon from "../../assets/icons/svgs/question.svg";
import * as styles from "./FAQSection.module.scss";

const FAQSection = () => {
  return (
    <div className={styles.wrapper}>
      <QuestionIcon className={styles.question} />
      <div className={styles.list}>
        <h6>Tid til årsrapport?</h6>

        <ul>
          <li>
            <Link to="/da/guide/praksis_krav">Bogføring</Link>
          </li>
          <li>
            <Link to="/da/guide/skat_selskabsskat">Selskabsskat</Link>
          </li>
          <li>
            <Link to="/da/guide/holdingselskab_og_sambeskatning">Sambeskatning</Link>
          </li>
          <li>
            <Link to="/da/guide/bogforing_til_arsrapport">Årsrapport</Link>
          </li>
          <li>
            <Link to="/da/guide/praksis_selskabets_selvangivelse">Selvangivelse</Link>
          </li>
        </ul>
      </div>

      <div className={styles.list}>
        <h6>Hvad gør jeg for at....?</h6>

        <ul>
          <li>
            <Link to="/da/guide/penge_udbytte">Udbetale udbytte</Link>
          </li>
          <li>
            <Link to="/da/guide/penge_loen">Udbetale løn</Link>
          </li>
          <li>
            <Link to="/da/guide/penge_gave_til_born">Overdrage til mine børn</Link>
          </li>
        </ul>
      </div>

      <div className={styles.list}>
        <h6>Hvordan investerer jeg i?</h6>

        <ul>
          <li>
            <Link to="/da/guide/invest_unoteret">Ejerandele i unoterede selskaber</Link>
          </li>
          <li>
            <Link to="/da/guide/invest_noteret">Aktier og andre værdipapirer</Link>
          </li>
          <li>
            <Link to="/da/guide/invest_ejendomme">Ejendomme</Link>
          </li>
          <li>
            <Link to="/da/guide/invest_privateequity">Private equity</Link>
          </li>
          <li>
            <Link to="/da/guide/invest_alternativer">Alternativer</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FAQSection;
